export default function() {
  const widgetName = 'cardWidgetQuickRates';
  const widgetOpts = cardWidgetQuickRatesOpts;

  const widgetHeadline = "<h2>Quick Rates</h2>";
  $(widgetHeadline).insertBefore(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      // const lastItem = `
      //   <a href="/p/manage/current-rates" class="card-widget-item all-rates">
      //     <div class="image-container"></div>
      //     <div class="card-content">
      //       <span class="card-widget-title">View All Rates</span>
      //     </div>
      //   </a>
      // `;
      // $(`#${widgetName}`).append(lastItem);

      const lastItem = $(`#${widgetName} .card-widget-item`).last();
      const lastItemDesc = lastItem.find('.card-widget-description');
      lastItem.addClass('all-rates');
      if (lastItemDesc.text() === 'null') {
        lastItemDesc.remove();
      }

      function quickRatesFadeIn() {
        let options = {
          threshold: 0.25,
        }
        let intersectionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // element is in viewport, do the stuff
              // console.log(entry.isIntersecting)
              $(`#${widgetName} .card-widget-item`).each(function(i) {
                let $t = $(this);
                $t.css('transition-delay', `${0.25*i}s`)
                $t.addClass('animate__slide-in-up');
              });
              // it's good to remove observer,
              // if you don't need it any more
              observer.unobserve(entry.target);
            }
          });
        }, options);
        
        // start observing your elements
        intersectionObserver.observe(document.getElementById('cardWidgetQuickRates'));
      }

      if ('IntersectionObserver' in window) {
        $(`#${widgetName}`).addClass('io-supported');
        quickRatesFadeIn();
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}